import { render, staticRenderFns } from "./LeyendaColorPlano.vue?vue&type=template&id=d8cf67f0&scoped=true"
var script = {}
import style0 from "./LeyendaColorPlano.vue?vue&type=style&index=0&id=d8cf67f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8cf67f0",
  null
  
)

export default component.exports